import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { GdprStorage } from "shared/src/uidispatcherapi/GdprStorage";

import { Store } from "shared/src/stores/Store";
import { isFsdShop, isStoreShop } from "shared/src/utils/ShopFlavor";
import CustomerStore from "../CustomerStore";

import { fsdFilterAlwaysActiveForStoreDeliveryCustomers } from "../../searchdiscover/toggles";

const FSD_FILTER_SETTING = "fsdFilter";

class CustomerSettingsStoreClass extends Store {
    // the ! are necessary because we initialize the fields in _reset, not the constructor
    localstorage!: any;
    _fsdFilterWasApplicable!: boolean;
    _wasReady!: boolean;

    constructor() {
        super();
        this.listenTo(CustomerStore, this._handleCustomerStoreUpdate);
        this._reset();
    }

    // necessary for testing
    _reset() {
        this.localstorage = GdprStorage.localStorage;
        this._fsdFilterWasApplicable = this._isToggleableFsdFilter();
        this._wasReady = this.isReady();
    }

    isReady() {
        return !CustomerStore.isLoading();
    }

    _handleCustomerStoreUpdate() {
        if (this._fsdFilterWasApplicable !== this._isToggleableFsdFilter() || this._wasReady !== this.isReady()) {
            this._fsdFilterWasApplicable = this._isToggleableFsdFilter();
            this._wasReady = this.isReady();
            this.trigger();
        }
    }

    _isToggleableFsdFilter() {
        return (
            (SessionStore.isMarioCountry() || CountryUtil.getOptionalConfig().showFSDFilter) &&
            CustomerStore.isCurrentCustomerFsdCustomerInSelectedStore() &&
            !isFsdShop()
        );
    }

    isFsdFilterAlwaysActive() {
        return (
            fsdFilterAlwaysActiveForStoreDeliveryCustomers() &&
            CustomerStore.isCurrentCustomerFsdCustomerInSelectedStore() &&
            isStoreShop()
        );
    }

    isFsdFilterActive() {
        // in these shop flavors, the FSD filter is always active resp. not active
        if (isFsdShop() || this.isFsdFilterAlwaysActive()) {
            return true;
        }

        if (!this._isToggleableFsdFilter()) {
            return false;
        }

        const filterDefaultSetting = !!CountryUtil.getOptionalConfig().defaultFilterOnlyFSD;
        const rawResult = this.localstorage.get(FSD_FILTER_SETTING);
        if (!rawResult || !rawResult.actualResult) {
            return filterDefaultSetting;
        }
        const result = JSON.parse(rawResult.actualResult);
        const customerId = SessionStore.getCustomerId();
        if (result === null || result.customer !== customerId || result.filter === undefined) {
            return filterDefaultSetting;
        }

        return result.filter === "true" || result.filter === true;
    }

    setFsdFilter(newState: boolean) {
        if (this._isToggleableFsdFilter()) {
            const data = {
                customer: SessionStore.getCustomerId(),
                filter: newState
            };
            this.localstorage.put(FSD_FILTER_SETTING, JSON.stringify(data), GdprStorage.NECESSARY);
            this.trigger();
        }
    }
}

const CustomerSettingsStore = new CustomerSettingsStoreClass();
export default CustomerSettingsStore;
